export * from './env';
export * from './menuKeys';
export * from './storageKeys';

export const KeyCode = {
  enter: 13,
};
